// Atlas Career Solutions Learning Suite - Complete Module Data
export const LEARNING_MODULES = [
  {
    id: 1,
    number: "MODULE 1",
    title: "Career Direction & Professional Identity",
    subheading: "Define your professional identity and direction.",
    icon: "compass",
    color: "amber",
    learningObjective: "Help users identify transferable strengths, clarify career direction, and establish a strong professional identity.",
    items: [
      {
        id: "m1_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=HAnw168huqA",
        subtitle: "15 min | Communication Foundations",
        actionStep: "Write a 2–3 sentence professional introduction describing your background and value."
      },
      {
        id: "m1_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=MzVvaw_TPr4",
        subtitle: "10 min | Military-to-Civilian Transition",
        actionStep: "Identify three military experiences that translate into civilian leadership skills."
      },
      {
        id: "m1_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/watch?v=NdgnHXR4Do8",
        subtitle: "12 min | Skill Translation Strategy",
        actionStep: "Rewrite one military responsibility into civilian-friendly language."
      }
    ]
  },
  {
    id: 2,
    number: "MODULE 2",
    title: "Personal Brand & Professional Positioning",
    subheading: "Build your market-facing professional image.",
    icon: "user-check",
    color: "blue",
    learningObjective: "Teach users how to position themselves through branding, resumes, and LinkedIn presence.",
    items: [
      {
        id: "m2_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=lkdZLVpsiLQ",
        subtitle: "9 min | Personal Branding Fundamentals",
        actionStep: "Write a draft personal brand statement (1 sentence)."
      },
      {
        id: "m2_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=ReYHbLr_G0E",
        subtitle: "10 min | Recruiter Perspective on LinkedIn",
        actionStep: "Update your LinkedIn headline using role + expertise + value format."
      },
      {
        id: "m2_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/watch?v=C-4-fmSsbc8",
        subtitle: "12 min | Profile Optimization",
        actionStep: "Add measurable results to one LinkedIn experience entry."
      }
    ]
  },
  {
    id: 3,
    number: "MODULE 3",
    title: "Communication & Interview Mastery",
    subheading: "Communicate clearly and confidently under pressure.",
    icon: "mic",
    color: "emerald",
    learningObjective: "Build executive-level communication and interviewing confidence.",
    items: [
      {
        id: "m3_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=HAnw168huqA",
        subtitle: "15 min | Thinking Fast & Speaking Clearly",
        actionStep: "Practice answering \"Tell me about yourself\" using a structured framework."
      },
      {
        id: "m3_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=g3JRONajB7w",
        subtitle: "8 min | Speaking Without Notes",
        actionStep: "Record yourself answering one interview question without preparation."
      },
      {
        id: "m3_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/watch?v=Fsr4yrSAIAQ",
        subtitle: "10 min | Memorable Communication",
        actionStep: "Rewrite one career story using Situation → Action → Result."
      }
    ]
  },
  {
    id: 4,
    number: "MODULE 4",
    title: "Leadership & Professional Presence",
    subheading: "Lead with confidence in professional environments.",
    icon: "crown",
    color: "purple",
    learningObjective: "Develop leadership mindset, credibility, and professional influence.",
    items: [
      {
        id: "m4_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=WIHwMJF-Bzk",
        subtitle: "12 min | Leadership Communication",
        actionStep: "Identify one habit that improves your executive presence."
      },
      {
        id: "m4_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=73IGV2SxAWc",
        subtitle: "10 min | Building Professional Reputation",
        actionStep: "Define three traits you want colleagues to associate with you."
      },
      {
        id: "m4_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/watch?v=yRHApQ4TzaM",
        subtitle: "9 min | Handling Difficult Conversations",
        actionStep: "Write a calm response to a hypothetical workplace disagreement."
      }
    ]
  },
  {
    id: 5,
    number: "MODULE 5",
    title: "Problem Solving & Strategic Thinking",
    subheading: "Think analytically and solve problems effectively.",
    icon: "puzzle",
    color: "orange",
    learningObjective: "Teach structured thinking and decision-making frameworks.",
    items: [
      {
        id: "m5_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=bFQJDpPwnmE",
        subtitle: "10 min | Strategic Communication Choices",
        actionStep: "Break down a recent challenge into problem → solution → outcome."
      },
      {
        id: "m5_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=VPEVACWJ-Xg",
        subtitle: "12 min | Goal Setting Frameworks",
        actionStep: "Set one 30-day professional development goal."
      },
      {
        id: "m5_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/playlist?list=PLxq_lXOUlvQDgCVFj9L79kqJybW0k6OaB",
        subtitle: "Multi-part | Strategic Thinking Practice",
        actionStep: "Apply one framework from the session to your current career goal."
      }
    ]
  },
  {
    id: 6,
    number: "MODULE 6",
    title: "Workplace Success & Career Growth",
    subheading: "Thrive and grow after getting hired.",
    icon: "rocket",
    color: "teal",
    learningObjective: "Prepare users to succeed in their first months and beyond.",
    items: [
      {
        id: "m6_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=Bb8i3Lm4BX0",
        subtitle: "8 min | Workplace Culture & Success",
        actionStep: "List three behaviors that build trust in a new team."
      },
      {
        id: "m6_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=jw_-OSxk36U",
        subtitle: "10 min | Thinking Faster at Work",
        actionStep: "Practice summarizing a complex idea in under 60 seconds."
      },
      {
        id: "m6_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/@ThinkFastTalkSmart",
        subtitle: "Ongoing | Workplace Communication Library",
        actionStep: "Choose one communication technique to apply this week."
      }
    ]
  },
  {
    id: 7,
    number: "MODULE 7",
    title: "Compensation, Negotiation & Career Mobility",
    subheading: "Advance strategically and negotiate with confidence.",
    icon: "dollar-sign",
    color: "green",
    learningObjective: "Help users understand compensation, negotiation, and career growth decisions.",
    items: [
      {
        id: "m7_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=WIHwMJF-Bzk",
        subtitle: "12 min | Leadership Dialogue & Influence",
        actionStep: "Write one sentence describing your ideal compensation value."
      },
      {
        id: "m7_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=73IGV2SxAWc",
        subtitle: "10 min | Trust & Competence Signals",
        actionStep: "Identify two strengths you would highlight in a salary discussion."
      },
      {
        id: "m7_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/playlist?list=PL6caGRBUYZCmgDGM2RK6mxKB9jG_ccmm3",
        subtitle: "Multi-part | Leadership Communication Skills",
        actionStep: "Draft a negotiation opening statement."
      }
    ]
  },
  {
    id: 8,
    number: "MODULE 8",
    title: "AI & Future of Work",
    subheading: "Build future-ready professional skills.",
    icon: "cpu",
    color: "indigo",
    learningObjective: "Prepare users to adapt to AI-driven workplaces and modern career environments.",
    items: [
      {
        id: "m8_l1",
        type: "Learning Session",
        videoUrl: "https://www.youtube.com/watch?v=WIHwMJF-Bzk",
        subtitle: "12 min | Future Communication & Leadership",
        actionStep: "Identify one way AI could improve your daily workflow."
      },
      {
        id: "m8_l2",
        type: "Executive Insight",
        videoUrl: "https://www.youtube.com/watch?v=jw_-OSxk36U",
        subtitle: "10 min | Adaptability & Cognitive Agility",
        actionStep: "List one skill you want to future-proof over the next year."
      },
      {
        id: "m8_l3",
        type: "Professional Skill Builder",
        videoUrl: "https://www.youtube.com/watch?v=HAnw168huqA",
        subtitle: "15 min | Communication for the Future Workplace",
        actionStep: "Practice explaining a complex idea clearly in 30 seconds."
      }
    ]
  }
];

// Helper function to get type badge color
export const getTypeBadgeColor = (type) => {
  switch (type) {
    case 'Learning Session':
      return 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-400';
    case 'Executive Insight':
      return 'bg-purple-100 text-purple-700 dark:bg-purple-900/50 dark:text-purple-400';
    case 'Professional Skill Builder':
      return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-400';
    default:
      return 'bg-gray-100 text-gray-700 dark:bg-gray-900/50 dark:text-gray-400';
  }
};

// Helper to get module color classes
export const getModuleColorClasses = (color) => {
  const colors = {
    amber: {
      bg: 'bg-amber-100 dark:bg-amber-900/50',
      text: 'text-amber-600 dark:text-amber-400',
      border: 'border-amber-200 dark:border-amber-800',
      gradient: 'from-amber-500 to-amber-600'
    },
    blue: {
      bg: 'bg-blue-100 dark:bg-blue-900/50',
      text: 'text-blue-600 dark:text-blue-400',
      border: 'border-blue-200 dark:border-blue-800',
      gradient: 'from-blue-500 to-blue-600'
    },
    emerald: {
      bg: 'bg-emerald-100 dark:bg-emerald-900/50',
      text: 'text-emerald-600 dark:text-emerald-400',
      border: 'border-emerald-200 dark:border-emerald-800',
      gradient: 'from-emerald-500 to-emerald-600'
    },
    purple: {
      bg: 'bg-purple-100 dark:bg-purple-900/50',
      text: 'text-purple-600 dark:text-purple-400',
      border: 'border-purple-200 dark:border-purple-800',
      gradient: 'from-purple-500 to-purple-600'
    },
    orange: {
      bg: 'bg-orange-100 dark:bg-orange-900/50',
      text: 'text-orange-600 dark:text-orange-400',
      border: 'border-orange-200 dark:border-orange-800',
      gradient: 'from-orange-500 to-orange-600'
    },
    teal: {
      bg: 'bg-teal-100 dark:bg-teal-900/50',
      text: 'text-teal-600 dark:text-teal-400',
      border: 'border-teal-200 dark:border-teal-800',
      gradient: 'from-teal-500 to-teal-600'
    },
    green: {
      bg: 'bg-green-100 dark:bg-green-900/50',
      text: 'text-green-600 dark:text-green-400',
      border: 'border-green-200 dark:border-green-800',
      gradient: 'from-green-500 to-green-600'
    },
    indigo: {
      bg: 'bg-indigo-100 dark:bg-indigo-900/50',
      text: 'text-indigo-600 dark:text-indigo-400',
      border: 'border-indigo-200 dark:border-indigo-800',
      gradient: 'from-indigo-500 to-indigo-600'
    }
  };
  return colors[color] || colors.amber;
};

// Helper to extract YouTube video ID
export const getYouTubeVideoId = (url) => {
  if (!url) return null;
  
  // Handle channel URLs - return null as they can't be embedded
  if (url.includes('@')) return null;
  
  // Handle playlist URLs
  if (url.includes('playlist?list=')) {
    const match = url.match(/list=([a-zA-Z0-9_-]+)/);
    return match ? { type: 'playlist', id: match[1] } : null;
  }
  
  // Handle regular video URLs
  const videoMatch = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([^"&?\/\s]{11})/);
  return videoMatch ? { type: 'video', id: videoMatch[1] } : null;
};

// Get embed URL
export const getEmbedUrl = (url) => {
  const parsed = getYouTubeVideoId(url);
  if (!parsed) return null;
  
  if (parsed.type === 'playlist') {
    return `https://www.youtube.com/embed/videoseries?list=${parsed.id}`;
  }
  return `https://www.youtube.com/embed/${parsed.id}`;
};
